import React from 'react';

import { Dayjs } from 'dayjs';

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import SouthIcon from '@mui/icons-material/South';
import { Box, Button, Divider, Stack } from '@mui/material';

import DateTimeWidget from '~/components/Common/Elements/DateTimeWidget';

const FULL_WIDTH_MAX_WIDTH = 680;

interface Props {
  disabled: boolean;
  schedule: Partial<App.Schedule>;
  startUpdated: boolean;
  endUpdated: boolean;
  onReset: () => void;
  updateEnd: (end: string) => void;
  updateStart: (start: string) => void;
  onApplyToAll?: () => void;
  enableUtilBtn?: boolean;
  minDate?: Dayjs;
  maxDate?: Dayjs;
  // Stretches the two date fields to fill the row instead of their default intrinsic width —
  // opt-in only, so existing callers (which rely on the compact default) are unaffected.
  fullWidth?: boolean;
}

export default function NewScheduleFormBase(props: Props) {
  const {
    disabled,
    schedule,
    startUpdated,
    endUpdated,
    onReset,
    updateEnd,
    updateStart,
    onApplyToAll,
    minDate,
    maxDate,
    fullWidth,
  } = props;

  const resetActive = endUpdated || startUpdated;

  return (
    <Box mt={1} sx={fullWidth ? { flexGrow: 1, maxWidth: FULL_WIDTH_MAX_WIDTH } : undefined}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems="center"
        justifyContent="center"
        spacing={2}
        sx={fullWidth ? { width: '100%' } : undefined}
      >
        <Box sx={fullWidth ? { flex: 1, minWidth: 0 } : undefined}>
          <DateTimeWidget
            disabled={disabled}
            value={schedule.start}
            onChange={updateStart}
            format="DD/MM/YYYY hh:mm a"
            label="Start"
            timeSteps={{ minutes: 1 }}
            minDate={minDate}
          />
        </Box>

        <ArrowRightAltIcon sx={{ display: { xs: 'none', sm: 'block' } }} />
        <SouthIcon sx={{ display: { xs: 'block', sm: 'none' } }} />
        <Box sx={fullWidth ? { flex: 1, minWidth: 0 } : undefined}>
          <DateTimeWidget
            disabled={disabled}
            value={schedule.end}
            onChange={updateEnd}
            format="DD/MM/YYYY hh:mm a"
            label="End"
            timeSteps={{ minutes: 1 }}
            maxDate={maxDate}
          />
        </Box>
        {props.enableUtilBtn && (
          <Stack direction="row" spacing={1}>
            <Button variant="text" onClick={onApplyToAll}>
              Apply To All
            </Button>
            <Divider orientation="vertical" flexItem />
            <Button variant="text" color={resetActive ? 'primary' : 'secondary'} onClick={onReset}>
              Reset
            </Button>
          </Stack>
        )}
      </Stack>
    </Box>
  );
}
